import React from 'react';
import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import './QueryErrorBoundary.css';

class ErrorBoundaryWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Caught error in ErrorBoundary:", error, info);
    if (this.props.onError) this.props.onError(error);
  }

  render() {
    if (this.state.error) {
      return null;
    }
    return this.props.children;
  }
}

export function QueryErrorBoundary({ children, fallback }) {
  const { reset } = useQueryErrorResetBoundary();
  const [error, setError] = React.useState(null);

  const handleRetry = () => {
    reset();
    setError(null);
  };

  return (
    <ErrorBoundaryWrapper onError={setError}>
      {error ? (
        <div className="qeb-container">
          <div className="qeb-card">
            <div className="qeb-icon">⚠️</div>
            <h2 className="qeb-title">{fallback || 'Something went wrong.'}</h2>
            <pre className="qeb-message">{error.message}</pre>
            <button className="qeb-button" onClick={handleRetry}>
              Retry
            </button>
          </div>
        </div>
      ) : (
        children
      )}
    </ErrorBoundaryWrapper>
  );
}